import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <div className="container">
        <div className="hero">
          <h1>Share your Telegram channels in one place</h1>
          <p className="hero-text">
            Channls is a link-in-bio service designed specifically for Telegram users.
            Collect and share all your Telegram channels, groups, and bots in one clean profile.
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary">Get Started</Link>
            <a href="https://t.me/channlverificationbot" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
              Try the Bot
            </a>
          </div>
        </div>
        
        <div className="features">
          <div className="feature-card">
            <h3>Easy Verification</h3>
            <p>Connect your Telegram account to verify ownership and manage your links.</p>
          </div>
          <div className="feature-card">
            <h3>Automatic Collection</h3>
            <p>Our bot automatically collects Telegram links you share and adds them to your profile.</p>
          </div>
          <div className="feature-card">
            <h3>Clean Profile</h3>
            <p>Get a beautiful profile page to share with your audience.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home; 